import type { AttendeeHistory } from "../types";
import { parseDecimalNumber } from "./number";

export function parseWeightKg(value: unknown): number | undefined {
  return parseDecimalNumber(value);
}

export function normalizeWeightKgForPayload(
  value: unknown,
): number | undefined {
  const weightKg = parseWeightKg(value);
  if (weightKg == null || weightKg <= 0) return undefined;
  return weightKg;
}

/**
 * History from `getAttendeeHistory` is sorted newest-first; returns the most
 * recent row that has a usable weight.
 */
export function latestWeightFromHistory(
  history: AttendeeHistory[],
): number | undefined {
  for (const record of history) {
    const w = normalizeWeightKgForPayload(record.weightKg);
    if (w !== undefined) return w;
  }
  return undefined;
}

export function resolvePetFormWeightKg(options: {
  history: AttendeeHistory[];
  /** e.g. attendee payload field when API includes it */
  attendeeWeightKg?: number | string | null;
}): number | undefined {
  const { history, attendeeWeightKg } = options;
  return (
    latestWeightFromHistory(history) ??
    normalizeWeightKgForPayload(attendeeWeightKg)
  );
}
